import type { JSX } from 'react'
import type { ITabProps } from '../Tab'

import { TextBoxColors } from 'atoms/TextBox'
import { CORNERS } from 'vars/corners'
import { Tab } from '../Tab'
import { TabBackground, TabPaddings } from '../Tab.h'

export interface ITabWithBackgroundProps extends ITabProps {}

export const TabWithBackground = ({
  title = '',
  selected,
  paddings = TabPaddings.SIZE_20,
  color = TextBoxColors.SURFACE_DARK_7,
  colorHovered = TextBoxColors.TEXT_ICON_SECONDARY,
  colorPressed = TextBoxColors.TEXT_ICON_SECONDARY,
  colorSelected = TextBoxColors.TEXT_ICON_CONSTANT_LIGHT,
  colorSelectedHovered = TextBoxColors.SURFACE_LIGHT_2,
  colorSelectedPressed = TextBoxColors.BASE_MAIN_PRESSED,
  background = TabBackground.COLOR_TRANSPARENT,
  backgroundHovered = TabBackground.COLOR_TRANSPARENT,
  backgroundPressed = TabBackground.SURFACE_OPACITY_LIGHT_10,
  backgroundDisabled = TabBackground.COLOR_TRANSPARENT,
  backgroundSelected = TabBackground.SURFACE_OPACITY_LIGHT_10,
  backgroundSelectedHovered = TabBackground.SURFACE_OPACITY_LIGHT_10,
  backgroundSelectedPressed = TabBackground.SURFACE_OPACITY_LIGHT_10,
  backgroundSelectedDisabled = TabBackground.COLOR_TRANSPARENT,
  corners = CORNERS.CORNERS_10,
  ...rest
}: ITabWithBackgroundProps): JSX.Element | null =>
  title ? (
    <Tab
      title={title}
      selected={selected}
      paddings={paddings}
      color={color}
      colorHovered={colorHovered}
      colorPressed={colorPressed}
      colorSelected={colorSelected}
      colorSelectedHovered={colorSelectedHovered}
      colorSelectedPressed={colorSelectedPressed}
      background={background}
      backgroundHovered={backgroundHovered}
      backgroundPressed={backgroundPressed}
      backgroundDisabled={backgroundDisabled}
      backgroundSelected={backgroundSelected}
      backgroundSelectedHovered={backgroundSelectedHovered}
      backgroundSelectedPressed={backgroundSelectedPressed}
      backgroundSelectedDisabled={backgroundSelectedDisabled}
      corners={corners}
      {...rest}
    />
  ) : null
